import React from "react";
import { getGenerateFSIPDF, getPortDetails } from "../../api/getEntrySummaryData";
// import { createMerchandiseDutyItem } from '../../api/createItem'
import store from "../../store";
import { Popup, Icon, Button } from "semantic-ui-react";
import flatten from "lodash/flatten";
import get from "lodash/get";


export function merchandiseListToTotalAmount(merchandiseLineItems){
  return ((flatten((merchandiseLineItems||[])
          .filter(a=>a.articleHeader!="V")
          .map(merch=>(merch.merchandiseDuties||[])
          .map(duty=>duty.invoiceCurrencyValue||0)))||[])
          .reduce((a,b)=>{return parseFloat(a)+parseFloat(b)},0) || 0)
}

export function getCommodityHTSOrPrimaryCommodity(dutyItem){
  let is9802Hts = (dutyItem?.htsus || "").startsWith("9802") && dutyItem.isCommodityDuty === 2;
  let htsChapter = parseInt((dutyItem?.htsus || "")?.slice(0, 2))
  let isCommodityHTS = (htsChapter !== 98 && htsChapter !== 99) || is9802Hts;
  let isCommodityDutyBoolean = dutyItem.isCommodityDuty === 1;
  if(isCommodityDutyBoolean && !isCommodityHTS)return false;
  return true;
}

export const displayMasterItem = (id, masterList) => {
  let result = id;
  let item;
  if (masterList) {
    item = masterList.find((obj) => obj.id === id);
    if (item && item.description) {
      if(item?.hidePrefixOnOption){
        return item.description;
      }
      result += " - " + item.description;
    }
  }
  return result;
};

export const universalFormValidate =(parentThis,setActiveAccordianIndex,updateMerchLineItemPgaObject,merchandiseId,
  flagName, lineItemIndex, invoiceItemIndex)=>{
  let { pgaGuid, formType, justinvalidatePGA } = parentThis.props;
  let allPGAValues = parentThis.props[Object.keys(parentThis.props).filter(aaa=>(aaa+"").includes("_Values")).find(onekey=>
    parentThis?.props[onekey]?.pgaGuid==pgaGuid
  )];
  if(allPGAValues?.disclaimFlag?.value && allPGAValues?.disclaimFlag?.value && parentThis.props?.updateMerchLineItemPgaFlagsNoSave ){
    parentThis.props.updateMerchLineItemPgaFlagsNoSave(merchandiseId, pgaGuid, {
      disclaimFlag: allPGAValues?.disclaimFlag?.value,
      disclaimCode: allPGAValues?.disclaimCode?.value,
    });
  }
  if(justinvalidatePGA){
    updateMerchLineItemPgaObject(
      merchandiseId,
      flagName,
      2, lineItemIndex, invoiceItemIndex, formType, pgaGuid
    )
  } else {

  parentThis.setState({errorMsg:{}},()=>{
    parentThis.validate()
    if (JSON.stringify(parentThis.state.errorMsg).length<10 || (window.LAST_ERRORS_GLOBALXX + 1000 > Date.now() && window.confirm("Validation errors, are you sure?"))) {
      setActiveAccordianIndex()
      updateMerchLineItemPgaObject(
        merchandiseId,
        flagName,
        1, lineItemIndex, invoiceItemIndex, formType, pgaGuid
      )
    } else {
      updateMerchLineItemPgaObject(
        merchandiseId,
        flagName,
        2, lineItemIndex, invoiceItemIndex, formType, pgaGuid
      )
    }
    window.LAST_ERRORS_GLOBALXX = Date.now();
  });
}
}

export const displayDropDownItem = (value, dropdownList) => {
  let result = value;
  let showNoneDescription = (stttr)=>{
    if(["none","n/a",'_blank_'].includes(stttr.toLowerCase()))return stttr;
    return "Please select..."
  }
  if(['_blank_'].includes((value+"").toLowerCase())){
    return "Please select..."
  }
  let item;
  if (dropdownList) {
    item = dropdownList.find((obj) => obj.value === value || obj.id === value);
    if (item && item.description) {
      if(item?.hidePrefixOnOption){
        return item.description;
      }
      if(!result){
        if (item.value === '' || item.value == null) {
          return `N/A${item.description ? ` - ${item.description}` : ''}`
        }
        result =showNoneDescription(item.description);
      } else {
        result += " - " + item.description;

      }
    } else if (item && item.key) {
      result = item.key;
    }
  }
  return result;
};

export const generateFSIPDF = (shipmentId, merchandiseId,pgaGuid) => {
  return getGenerateFSIPDF(shipmentId, merchandiseId,pgaGuid)
}
export const buildPortValue = (portCode, updateAction, portName) => {
  if (!portCode) {
    return {
      id: "",
      title: "",
      masterSet: false,
    };
  } else {
    getPortDetails(portCode)
      .then((response) => {
        let res = get(response, "data.eventMessage.list", []);
        if (res.length > 0) {
          if (portName) {
            let foundPort = {};
            let splitName = portName.split(",")[0] || "";

            for (let i = 0; i < res.length; i++) {
              if (res[i].portName.includes(splitName) || res[i].portName === splitName) {
                foundPort = res[i];
              }
            }
            store.dispatch(
              updateAction({
                id: foundPort.portCode || "",
                title: (foundPort.portName || "") + ", " + (foundPort.portProvince || ""),
                masterSet: Boolean(foundPort.portCode),
              }),
            );
          } else {
            store.dispatch(
              updateAction({
                id: res[0].portCode || "",
                title: (res[0].portName || "") + ", " + (res[0].portProvince || ""),
                masterSet: Boolean(res[0].portCode),
              }),
            );
          }
        }
      })
      .catch((err) => {
        console.log("Could not find port associated with Port Code:", portCode, err);
      });
  }
};

// Returns an icon as specified with text displaying on hover
export const getPopUpIcon = (icon, popupText, className, merchandiseId, lineItemIndex) => {
  return (
    <Popup
      trigger={<Icon className={className} name={icon} color={"blue"} />}
      hideOnScroll
      on="click"
      content={
        <Button
          className="footnote-button"
          onClick={
            () => {}
            // merchandiseId &&
            // createMerchandiseDutyItem(
            //   merchandiseId,
            //   lineItemIndex,
            //   null,
            //   popupText.replace(/[^0-9.]/g, '')
            // )
          }
        >
          {popupText}
          {/* {' '}
          <Icon name='add circle' /> */}
        </Button>
      }
    />
  );
};
